import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ListingsIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11H5C3.3457 11 2 9.6543 2 8V5C2 3.3457 3.3457 2 5 2H8C9.6543 2 11 3.3457 11 5V8C11 9.6543 9.6543 11 8 11ZM8 4C8.55176 4 9 4.44824 9 5V8C9 8.55176 8.55176 9 8 9H5C4.44824 9 4 8.55176 4 8V5C4 4.44824 4.44824 4 5 4H8Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 5.5V3.5H22V5.5H13Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 7.5H20.0714V9.5H13V7.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22H5C3.3457 22 2 20.6543 2 19V16C2 14.3457 3.3457 13 5 13H8C9.6543 13 11 14.3457 11 16V19C11 20.6543 9.6543 22 8 22ZM8 15C8.55176 15 9 15.4482 9 16V19C9 19.5518 8.55176 20 8 20H5C4.44824 20 4 19.5518 4 19V16C4 15.4482 4.44824 15 5 15H8Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 16.5V14.5H22V16.5H13Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 18.5H20.0714V20.5H13V18.5Z",
    fill: "currentColor"
  }));
}